/* Dirty Money — Theme JavaScript */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  const money = (cents) => {
    const amt = (cents / 100).toFixed(2);
    return (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'CZK') + amt;
  };
  window.formatMoney = (cents) => 'CZK' + (cents / 100).toFixed(2);

  /* ------------ Cart Drawer ------------ */
  const cartDrawer = {
    el: null,
    body: null,
    subtotal: null,
    freeShippingBar: null,
    threshold: 15000,
    open() { this.el && this.el.classList.add('is-open'); document.body.classList.add('no-scroll'); },
    close() { this.el && this.el.classList.remove('is-open'); document.body.classList.remove('no-scroll'); },
    async refresh() {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
      this.updateCount(cart.item_count);
    },
    updateCount(n) { $$('.cart-count').forEach(el => el.textContent = '(' + n + ')'); },
    render(cart) {
      if (!this.body) return;
      if (cart.item_count === 0) {
        this.body.innerHTML = '<div class="cart-drawer__empty"><h4>Your cart is empty</h4><a href="/collections/all" class="btn">Continue shopping</a></div>';
        if (this.freeShippingBar) this.freeShippingBar.style.display = 'none';
        if (this.subtotal) this.subtotal.style.display = 'none';
        return;
      }
      if (this.freeShippingBar) this.freeShippingBar.style.display = '';
      if (this.subtotal) this.subtotal.style.display = '';

      let html = '';
      cart.items.forEach(item => {
        const img = item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : '';
        html += `
          <div class="cart-item" data-key="${item.key}">
            <div class="cart-item__image">${img}</div>
            <div class="cart-item__info">
              <div class="cart-item__title"><a href="${item.url}">${item.product_title}</a></div>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
              <div class="cart-item__price">${window.formatMoney(item.final_line_price)}</div>
              <div class="cart-item__actions">
                <div class="quantity">
                  <button data-action="decrease" aria-label="Decrease">−</button>
                  <input type="number" value="${item.quantity}" min="0" data-line-key="${item.key}">
                  <button data-action="increase" aria-label="Increase">+</button>
                </div>
                <button class="cart-item__remove" data-remove="${item.key}">Remove</button>
              </div>
            </div>
          </div>`;
      });
      this.body.innerHTML = html;
      if (this.subtotal) this.subtotal.querySelector('[data-subtotal-amount]').textContent = window.formatMoney(cart.total_price);
      this.updateShippingBar(cart.total_price);
      this.bindItemEvents();
    },
    updateShippingBar(total) {
      if (!this.freeShippingBar) return;
      const remaining = Math.max(0, this.threshold - total);
      const pct = Math.min(100, (total / this.threshold) * 100);
      const fill = this.freeShippingBar.querySelector('.free-shipping-bar__fill');
      const text = this.freeShippingBar.querySelector('.free-shipping-bar__text');
      if (fill) fill.style.width = pct + '%';
      if (text) text.textContent = remaining <= 0 ? '★ You unlocked free shipping' : 'Spend ' + window.formatMoney(remaining) + ' more for free shipping';
    },
    bindItemEvents() {
      $$('.cart-item [data-remove]', this.body).forEach(btn => {
        btn.addEventListener('click', async () => {
          await this.updateItem(btn.dataset.remove, 0);
        });
      });
      $$('.cart-item input[data-line-key]', this.body).forEach(input => {
        input.addEventListener('change', async () => {
          await this.updateItem(input.dataset.lineKey, parseInt(input.value, 10));
        });
      });
      $$('.cart-item [data-action]', this.body).forEach(btn => {
        btn.addEventListener('click', async () => {
          const input = btn.parentElement.querySelector('input');
          let qty = parseInt(input.value, 10);
          qty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
          await this.updateItem(input.dataset.lineKey, qty);
        });
      });
    },
    async updateItem(key, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      const cart = await res.json();
      this.render(cart);
      this.updateCount(cart.item_count);
    },
    async addFromForm(form) {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (res.ok) {
        await this.refresh();
        this.open();
      } else {
        const err = await res.json();
        alert(err.description || 'Could not add to cart');
      }
    },
    init() {
      this.el = $('#CartDrawer');
      if (!this.el) return;
      this.body = $('[data-cart-items]', this.el);
      this.subtotal = $('[data-cart-subtotal]', this.el);
      this.freeShippingBar = $('.free-shipping-bar', this.el);
      const thresholdEl = this.el.dataset.threshold;
      if (thresholdEl) this.threshold = parseInt(thresholdEl, 10);

      $$('[data-cart-open]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); this.open(); }));
      $$('[data-drawer-close]', this.el).forEach(b => b.addEventListener('click', () => this.close()));

      // Intercept product forms
      $$('form[action^="/cart/add"]').forEach(form => {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.addFromForm(form);
        });
      });

      this.refresh();
    }
  };
  window.cartDrawer = cartDrawer;

  /* ------------ Search Drawer ------------ */
  const searchDrawer = {
    el: null,
    input: null,
    results: null,
    timer: null,
    open() { this.el && this.el.classList.add('is-open'); setTimeout(() => this.input && this.input.focus(), 200); },
    close() { this.el && this.el.classList.remove('is-open'); },
    async search(q) {
      if (!q || q.length < 2) { this.results.innerHTML = ''; return; }
      const res = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6');
      const data = await res.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (products.length === 0) {
        this.results.innerHTML = '<p style="padding:20px 0;color:var(--color-muted);letter-spacing:.1em;text-transform:uppercase;font-size:12px;">No results</p>';
        return;
      }
      let html = '';
      products.forEach(p => {
        const img = p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}" alt="${p.title}">` : '';
        html += `<a class="predictive-item" href="${p.url}">
          <div class="predictive-item__image">${img}</div>
          <div>
            <div class="predictive-item__title">${p.title}</div>
            <div class="cart-item__price">${p.price}</div>
          </div>
        </a>`;
      });
      html += `<a class="btn btn--outline btn--block" style="margin-top:20px" href="/search?q=${encodeURIComponent(q)}">View all results</a>`;
      this.results.innerHTML = html;
    },
    init() {
      this.el = $('#SearchDrawer');
      if (!this.el) return;
      this.input = $('input[type="search"]', this.el);
      this.results = $('.search-drawer__results', this.el);
      $$('[data-search-open]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); this.open(); }));
      $$('[data-search-close]', this.el).forEach(b => b.addEventListener('click', () => this.close()));
      if (this.input) {
        this.input.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.search(this.input.value), 250);
        });
      }
    }
  };

  /* ------------ Mobile Nav ------------ */
  const mobileNav = {
    init() {
      const nav = $('#MobileNav');
      if (!nav) return;
      $$('[data-mobile-nav-open]').forEach(b => b.addEventListener('click', () => { nav.classList.add('is-open'); document.body.classList.add('no-scroll'); }));
      $$('[data-mobile-nav-close]', nav).forEach(b => b.addEventListener('click', () => { nav.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }));
    }
  };

  /* ------------ Accordion ------------ */
  const accordion = {
    init() {
      $$('.accordion__trigger').forEach(btn => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.accordion__item');
          item.classList.toggle('is-open');
        });
      });
    }
  };

  /* ------------ Reveal on scroll ------------ */
  const reveal = {
    init() {
      if (!('IntersectionObserver' in window)) { $$('.reveal').forEach(el => el.classList.add('is-visible')); return; }
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.1 });
      $$('.reveal').forEach(el => io.observe(el));
    }
  };

  /* ------------ Product page: variant selection + quick add ------------ */
  const productForm = {
    init() {
      $$('[data-product-form]').forEach(form => {
        const variantData = JSON.parse(form.dataset.variants || '[]');
        const options = form.dataset.options ? JSON.parse(form.dataset.options) : [];
        const selected = options.slice();
        const priceEl = $('[data-product-price]', form.closest('section') || document);
        const idInput = $('[name="id"]', form);

        function updateVariant() {
          const match = variantData.find(v => v.options.every((o, i) => o === selected[i]));
          if (match) {
            idInput.value = match.id;
            const submit = $('[type="submit"]', form);
            if (submit) {
              submit.disabled = !match.available;
              submit.textContent = match.available ? (submit.dataset.defaultText || 'Add to cart') : 'Sold out';
            }
            if (priceEl && match.price != null) {
              priceEl.innerHTML = window.formatMoney(match.price) + (match.compare_at_price > match.price ? ' <s>' + window.formatMoney(match.compare_at_price) + '</s>' : '');
            }
          }
        }

        $$('.variant-options', form).forEach((group, idx) => {
          $$('.variant-option', group).forEach(opt => {
            opt.addEventListener('click', () => {
              $$('.variant-option', group).forEach(o => o.classList.remove('is-active'));
              opt.classList.add('is-active');
              selected[idx] = opt.dataset.value;
              updateVariant();
            });
          });
        });

        // Quantity controls
        $$('.quantity button', form).forEach(btn => {
          btn.addEventListener('click', () => {
            const input = $('input[name="quantity"]', form);
            if (!input) return;
            let v = parseInt(input.value, 10) || 1;
            v = btn.dataset.action === 'increase' ? v + 1 : Math.max(1, v - 1);
            input.value = v;
          });
        });

        updateVariant();
      });
    }
  };

  /* ------------ Newsletter (client-side thanks) ------------ */
  const newsletter = {
    init() {
      $$('form[data-newsletter]').forEach(form => {
        form.addEventListener('submit', () => {
          setTimeout(() => {
            const msg = form.querySelector('[data-newsletter-message]');
            if (msg) msg.textContent = 'Thanks for subscribing';
          }, 100);
        });
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    cartDrawer.init();
    searchDrawer.init();
    mobileNav.init();
    accordion.init();
    reveal.init();
    productForm.init();
    newsletter.init();
  });
})();
